import NiotaClassicApiService from '@/services/niotaClassicApiService';
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import formMixin from '../formMixin';
import { codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/base16-dark.css';
import 'codemirror/theme/duotone-light.css';
import 'codemirror/mode/javascript/javascript.js';
export default {
  name: 'NiotaClassicConsumersEdit',
  components: {
    codemirror
  },
  mixins: [formMixin],
  props: {
    consumerData: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      lclObject: {},
      lclObjectStr: '',
      tabItem: 1,
      // applButtons: [
      //   {
      //     title: this.$i18n_t('NiotaClassic.Consumers.addAppl'),
      //     icon: 'fal fa-plus',
      //     action: 'addAppl',
      //     valid: true,
      //   },
      // ],
      // ipButtons: [
      //   {
      //     title: this.$i18n_t('NiotaClassic.Consumers.addIpAddr'),
      //     icon: 'fal fa-plus',
      //     action: 'addIp',
      //     valid: true,
      //   },
      // ],
      // dpButtons: [
      //   {
      //     title: this.$i18n_t('NiotaClassic.Consumers.addDataPoint'),
      //     icon: 'fal fa-plus',
      //     action: 'addDp',
      //     valid: true,
      //   },
      // ],
      titleRules: [v => !!v || this.$i18n_t('Common.fieldRequired')],
      consumerCanBeEdited: true,
      cmOptions: {
        readOnly: true,
        tabSize: 4,
        mode: {
          name: 'javascript',
          json: true
        },
        firstLineNumber: 0,
        theme: this.$store.state.app.UiTheme ? 'base16-dark' : 'duotone-light',
        lineNumbers: true,
        line: true,
        foldGutter: true,
        styleActiveLine: true,
        styleSelectedText: true,
        hintOptions: {
          completeSingle: false
        },
        lineWrapping: false
      },
      connection: null,
      wsconnected: false
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    dpButtons() {
      return [{
        title: this.$i18n_t('NiotaClassic.Consumers.addDataPoint'),
        icon: 'fal fa-plus',
        action: 'addDp',
        valid: this.isIotHubManager
      }];
    },
    applButtons() {
      return [{
        title: this.$i18n_t('NiotaClassic.Consumers.addAppl'),
        icon: 'fal fa-plus',
        action: 'addAppl',
        valid: this.isIotHubManager
      }];
    },
    ipButtons() {
      return [{
        title: this.$i18n_t('NiotaClassic.Consumers.addIpAddr'),
        icon: 'fal fa-plus',
        action: 'addIp',
        valid: this.isIotHubManager
      }];
    }
  },
  watch: {
    consumerData() {
      this.lclObject = cloneDeep(this.consumerData.data.consumer);
      if (this.consumerData.data.consumer.type === 'Websocket') {
        this.teardownWebSocket();
        this.setupN1WebSocket(this.consumerData.data.consumer.id, this.consumerData.data.consumer.apiKey);
      } else if (this.consumerData.data.consumer.type === 'MQTT') {
        this.loadConsumerMQTTdata(this.consumerData.data.consumer.id);
      } else if (this.consumerData.data.consumer.type === 'IEC-60870-5-104') {
        if (!this.lclObject.options.wValue && !this.lclObject.options.kValue && !this.lclObject.options.port && !this.lclObject.options.t1 && !this.lclObject.options.t2 && !this.lclObject.options.t3 && !this.lclObject.options.dataPollingInterval) {
          this.setIecDefaults();
        }
      }
    }
  },
  destroyed() {
    this.teardownWebSocket();
  },
  methods: {
    onCmFocus() {
      this.refreshForm();
      this.cmOptions.lineNumbers = true;
    },
    loadConsumerMQTTdata(a) {
      NiotaClassicApiService.consumersGetMQTTdata(a).then(res => {
        this.lclObjectStr = `MQTT Configuration: ${JSON.stringify(res.data.mqtt, null, 2)}`;
      }).catch(error => {
        console.error('Error fetching consumer mqtt data', error);
      });
    },
    addAppl() {
      this.$refs.applTable.dialogAdd = true;
    },
    addIp() {
      this.$refs.ipsTable.initIp();
      this.$refs.ipsTable.dialogAdd = true;
    },
    addDp() {
      this.$refs.dpsTable.initDataPoint();
      this.$refs.dpsTable.dialogAdd = true;
    },
    setupN1WebSocket(id, key) {
      this.lclObjectStr = 'Establishing connection\n';
      this.connection = new WebSocket(`ws${this.n1Protocol === 'https' ? 's' : ''}://${this.n1Host}/api/x/websocket/consumers/${id}?auth=${key}`);
      const instance = this;
      this.connection.onmessage = function (event) {
        instance.lclObjectStr += `Data-Packet START:\n${event.data}\nData-Packet END\n`;
      };
      this.connection.onopen = function () {
        instance.lclObjectStr += 'Successfully connected to the websocket server\nWaiting for data...\n';
        instance.wsconnected = true;
      };
      this.connection.onerror = function (error) {
        instance.lclObjectStr += `An error occurred: ${error}\n`;
      };
      this.connection.onclose = function () {
        instance.lclObjectStr += 'Disconnected from WebSocket Server\n';
      };
    },
    jsonTrafoChanged(data) {
      if (data == null) {
        delete this.lclObject.options['transform_template'];
      } else {
        this.lclObject.options.transform_template = data;
      }
    },
    teardownWebSocket() {
      if (get(this.consumerData, 'data.consumer.type') === 'Websocket' && this.connection) {
        this.connection.close();
      }
    },
    setIecDefaults() {
      this.lclObject.options.wValue = 8;
      this.lclObject.options.kValue = 12;
      this.lclObject.options.port = 2404;
      this.lclObject.options.t1 = 15;
      this.lclObject.options.t2 = 10;
      this.lclObject.options.t3 = 20;
      this.lclObject.options.dataPollingInterval = 60;
    },
    validateDataPoints() {
      let {
        validation,
        dataPoints
      } = this.$refs.dpsTable.validateAllDataPoints();
      this.lclObject.options.dataPoints = dataPoints;
      return validation;
    },
    copyToClipboard(refId) {
      let element = this.$refs[refId];
      if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(element.innerHTML);
      } else {
        var range;
        if (document.selection) {
          // IE
          range = document.body.createTextRange();
          range.moveToElementText(element);
          range.select();
        } else if (window.getSelection) {
          range = document.createRange();
          range.selectNode(element);
          window.getSelection().removeAllRanges();
          window.getSelection().addRange(range);
        }
        document.execCommand('copy');
        if (document.selection) {
          document.selection.empty();
        } else {
          window.getSelection().removeAllRanges();
        }
      }
    }
  }
};